import ItemFilter from './ItemFilter';

class RecordTypeFilter extends ItemFilter<string> {
  matches(record: { typename: string }) {
    return super.matches(record) || this.itemIsSelected(record.typename);
  }
}

export default RecordTypeFilter;
